<template>
    <div class="mt-5">
      <h2>{{ esEdicion ? 'Editar Tarea' : 'Nueva Tarea' }}</h2>
      <form @submit.prevent="submitForm">
        <!-- Componente Hijo: Datos Básicos -->
        <DatosBasicosTarea @actualizar-datos-basicos="actualizarDatosBasicos" />
  
        <!-- Componente Hijo: Objetivo de la Tarea -->
        <ObjetivoTarea
          :selected-tipo-objeto="tarea.tipo_objeto"
          :selected-objeto="tarea.objeto_id"
          @actualizar-objetivo="actualizarObjetivo"
          :es-edicion="esEdicion"
        />
  
        <!-- Componente Hijo: Detalles de la Tarea -->
        <DetallesTarea
            :proyecto_id="proyecto_id"
            :proyecto_evento_id="proyecto_evento_id"
            :es-edicion="esEdicion"
            @actualizar-detalles="actualizarDetalles"
        />

        <!-- Componente Hijo: Consumibles y Recursos -->
        <ConsumiblesRecursos @actualizar-consumibles-recursos="actualizarConsumiblesRecursos" />


         <!-- Componente Hijo: CumplimientoSelector -->
       <CumplimientoSelector @actualizar-cumplimiento="actualizarCumplimiento" />




        <!-- Botón para enviar el formulario -->
        <button type="submit" class="btn btn-primary">Guardar Tarea</button>
        <button type="button" class="btn btn-secondary" @click="cancelar">Cancelar</button>
      </form>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import DatosBasicosTarea from './DatosBasicosTarea.vue';
  import ObjetivoTarea from './ObjetivoTarea.vue';
  import DetallesTarea from './DetallesTarea.vue';
  import ConsumiblesRecursos from './ConsumiblesRecursos.vue';
  import CumplimientoSelector from './CumplimientoSelector.vue';
  
  export default {
        components: {
            DatosBasicosTarea,
            ObjetivoTarea,
            DetallesTarea,
            ConsumiblesRecursos,
            CumplimientoSelector,
        },
    props: {
        proyecto_evento_id: {
        type: Number,
        required: true,
        },
        proyecto_id: {
        type: Number,
        required: true,
    },
    },
    data() {
      return {
        esEdicion: false, // Cambiar a true si es edición
        tarea: {
          fecha_creacion: '',
          tipo_objeto: '',
          objeto_id: '',
          proyecto_evento_id: this.proyecto_evento_id,
          plan_cultivo_actividades_id: '',
          cumpli_grupo_id: null,
          cumpli_etiqueta_id: null,
          // Otros campos adicionales
        },
      };
    },
    methods: {
      actualizarDatosBasicos(datos) {
        this.tarea = { ...this.tarea, ...datos };
      },
      actualizarObjetivo(datos) {
        this.tarea = { ...this.tarea, ...datos };
      },
        actualizarDetalles(datos) {
            this.tarea = { ...this.tarea, ...datos };
        },
        actualizarConsumiblesRecursos(datos) {
            
            this.tarea = { ...this.tarea, tarea_usa_items: datos };
        },
        actualizarCumplimiento({ grupoId, etiquetaId }) {
          this.tarea.cumpli_grupo_id = grupoId;
          this.tarea.cumpli_etiqueta_id = etiquetaId;
        },
        submitForm() {
            if (this.validarFormulario()) {
                this.enviarTarea();
            } else {
                alert('Por favor, complete todos los campos requeridos.');
            }
        },
        validarFormulario() {
        return true;
        },
        async enviarTarea() {
        try {
            await axios.post('/api/tareas', this.tarea);
            alert('Tarea creada exitosamente.');
            this.$emit('tareaCreada', this.tarea); // Emitir evento para notificar al padre
        } catch (error) {
            console.error('Error al enviar la tarea:', error);
            alert('Error '+error.response.data.error);
        }
        },
        cancelar() {
            this.$emit('cancelar');
        },
    },
  };
  </script>
  